'use strict';

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const BaseAxisController=require('../../../../dist-es6/client/directives/plotting/baseAxisController');
const BaseAxisDirective=require('../../../../dist-es6/client/directives/plotting/baseAxisDirective');let

TimeAxisController=class TimeAxisController extends BaseAxisController{
constructor($scope){
super($scope);
}

get _scaleCreator(){
return d3.time.scale();
}};let


TimeAxisDirective=class TimeAxisDirective extends BaseAxisDirective{
get controller(){return TimeAxisController}};


module.exports=TimeAxisDirective;
//# sourceMappingURL=timeAxisDirective.js.map
